import React from 'react'
import { NextPage } from 'next'
import { enToCategoryCodename } from '@components/_faq/questions'
import { getPageByCodename, SingleItemResponse } from '@lib/kontent'
import Detail from '../_faq/detail'
import { FaqPage } from '@lib/kontent/models/FaqPage'

type Props = SingleItemResponse<FaqPage> & {
  slug: string
}

const FaqDetail: NextPage<Props> = props => <Detail {...props} />

export const getStaticProps = async ({ params, preview }) => {
  const { lang, slug } = params
  try {
    const content = await getPageByCodename({ codename: 'faq_page', lang, preview })

    return {
      props: { ...content, slug }
    }
  } catch (error) {
    throw error
  }
}

export const getStaticPaths = () => {
  const paths = []
  Object.keys(enToCategoryCodename).forEach(slug => {
    paths.push({ params: { lang: 'en', slug: slug } })
  })
  return {
    paths,
    fallback: false
  }
}

export default FaqDetail
